import {Component, OnInit} from '@angular/core';
import {Player} from "../player";
import {PlayerService} from "../player.service";
import {PlayersAnswer} from "../players-answer";
import {QuestionService} from "../question.service";
import {Question} from "../question";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {Quiz} from "../quiz";
import {QuizService} from "../quiz.service";

@Component({
  selector: 'app-player-table',
  templateUrl: 'players-table.component.html',
  styleUrls: ['./players-table.component.css']
})
export class PlayerTableComponent implements OnInit {
  public players: Player[] = [];
  public answers: PlayersAnswer[] = null;
  public quizzes: Quiz[] = null;
  public activePlayer: Player;

  public newAnswer: PlayersAnswer;
  public newAnswerScore: number = 0;

  public questionsMenu: {id: string, label: string}[] = [];
  public selectedQuestionID: string = null;

  constructor(private playerService: PlayerService,
              public questionService: QuestionService,
              public quizService: QuizService,
              private route: ActivatedRoute,
              private router: Router) {
    quizService.quizzes$.subscribe(quizzes => this.quizzes = quizzes.sort((a, b) => {
      if (a.quizName_fi < b.quizName_fi) {
        return -1;
      }
      if (a.quizName_fi > b.quizName_fi) {
        return 1;
      }
      return 0;
    }));

    this.playerService.players$.subscribe(
      players => {
        this.players = players;
        let playerID = this.route.snapshot.params["playerID"];
        //console.log(playerID);
        if (playerID && this.players) {
          this.activePlayer = this.players.find(function (player) {
            return player._id == playerID;
          });
          //console.log("set active player", this.activePlayer);
        }
      });

    this.playerService.answers$.subscribe(answers => this.answers = answers);
    this.newAnswer = new PlayersAnswer();
    this.questionService.questions$.subscribe(questions => {
      if (questions != null) {
        this.questionsMenu = [];
        for (let i = 0; i < questions.length; ++i) {
          this.questionsMenu.push(
            {
              id: questions[i]._id,
              label: (questions[i].questionLabel_fi == null ? "" : (questions[i].questionLabel_fi.length > 30 ? questions[i].questionLabel_fi.substring(0, 27) + "..." : questions[i].questionLabel_fi))
            }
          );
        }
        this.questionsMenu.sort(function(a, b) {
          let nameA = a.label.toUpperCase(); // ignore upper and lowercase
          let nameB = b.label.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        this.selectedQuestionID = this.questionsMenu.length > 0 ? this.questionsMenu[0].id : "";
      }

    });
  }

  ngOnInit() {
    let playerID = this.route.snapshot.params["playerID"];
    //console.log(playerID);
    if (playerID && this.players) {
      this.activePlayer = this.players.find(function (player) {
        return player._id == playerID;
      });
      //console.log("set active player", this.activePlayer);
    }
  }

  removeAllFromQuiz(quiz: Quiz){

    let confirmation: boolean = confirm(`Haluatko varmasti poistaa kaikki visaan liittyvät pelaajat ja näiden pelaajien vastaukset?
\r\nKyseiset pelaajat häviävät myös muista visoista, joihin ovat osallistuneet.`);
    if (!confirmation) { return; }

    this.quizService.clearQuiz(quiz).subscribe(
      (res) => {

        if (res.status === 500){
          alert("Poisto epäonnistui - tietokantavirhe");
        }
        else {
          const data = res.json();
          this.playerService.players$.next(data.players);
          this.playerService.answers$.next(data.answers);
          alert("Pelaajien ja vastausten poisto onnistui!");
        }
      },
      err => {
        alert("Poisto epäonnistui - palvelin tai kommunikaatiovirhe.");
        console.error(err);
      });


  }

  remove(player: Player) {
    let r: boolean = confirm("Haluatko varmasti poistaa pelaajan " + player.name);
    if (r == true) {
      this.playerService.removePlayer(player._id).subscribe(res => {
        if (res) {
          alert("Pelaajan poisto onnistui!");
        }
        else {
          alert("Pelaajan poisto epäonnistui!");
        }
      });
    } else {
      //do nothing
    }
  }

  save(player: Player) {
    if (player._id) {
      this.playerService.updatePlayer(player)
        .subscribe(
          res => {
            if (res) {
              this.activePlayer = null;
              alert("Pelaajan tallennus onnistui!");
            }
            else {
              alert("Pelaajan tallennus epäonnistui!");
            }
          },
          err => {
            alert("Pelaajan epäonnistui pahasti!");
          }
        );
    }
    else {
      this.playerService.addPlayer(player)
        .subscribe(
          res => {
            if (res) {
              this.activePlayer = null;
              alert("Uuden Pelaajan luonti onnistui!");
            }
            else {
              alert("Uuden Pelaajan luonti epäonnistui!");
            }
          },
          err => {
            alert("Uuden Pelaajan luonti pahasti!");
          });
    }
  }

  addNewPlayer(): void {
    this.activePlayer = new Player();
    this.activePlayer.name = "nimetön";
    this.activePlayer.email = "sähköposti";
    this.activePlayer.school = "koulu";
  }

  getScore(player: Player): string {
    let sum = 0;
    if (!this.answers || !player) {
      return "Ladataan...";
    }
    for (let answer of this.answers) {
      if (answer.playerID == player._id) {
        let question: Question = this.questionService.getQuestion(answer.questionID);
        if (!question || !question.scoreable) {
          continue;
        }
        for (let a of answer.answerArray) {
          sum += a.score;
        }
      }
    }
    return "" + sum;
  }

  edit(player: Player) {
    this.activePlayer = player;
    //user route
    this.router.navigate(['/admin/players/', player._id]);
  }

  public getQuestionLabel_fi(questionID: string): string {
    let question: Question = this.questionService.getQuestion(questionID);
    if (question) {

      return question.questionLabel_fi;
    }
    else {
      return "Ei kysymystä";
    }
  }

  cancel() {
    this.playerService.loadPlayerList();
    this.activePlayer = null;
    this.router.navigate(['/admin/players/']);

  }

  resetPassword(player: Player): void {
    console.log("Reset password for " + player);
    alert("Pelaajan uusi salasana lähetetty sähköpostiin");
  }

  public getAnswerString(answer: PlayersAnswer): string {
    let result: string = "";
    for (let a of answer.answerArray) {
      result += "[" + a.answerLabel_fi + "(" + a.score + ")] ";
    }
    return result;
  }

  public getScoreString(answer: PlayersAnswer): string {
    let result: number = 0;
    let question: Question = this.questionService.getQuestion(answer.questionID);
    for (let a of answer.answerArray) {
      result += a.score;
    }
    if (!question || !question.scoreable) {
      return "Ei pisteytetä (" + result + ")";
    }
    return "" + result;
  }

  public removeAnswer(answer: PlayersAnswer): void {
    let id = answer._id;
    this.playerService.removeAnswer(id).subscribe(res => {
      if (res) {
        alert("Kysymyksen poisto onnistui!");
      }
      else {
        alert("Kysymyksen poisto epäonnistui!");
      }
    });
  }

  public addNewAnswer(): void {
    this.newAnswer.playerID = this.activePlayer._id;
    this.newAnswer.questionID = this.selectedQuestionID;
    this.newAnswer.answerArray = [{
      answerLabel_fi: "käsin",
      answerLabel_sv: "käsin",
      answerLabel_en: "manual",
      score: this.newAnswerScore
    }];
    console.log("this.newAnswer.questionID",this.newAnswer.questionID)
    this.playerService.addNewAnswer(this.newAnswer).subscribe(res => {
      if (res) {
        alert("Vastauksen lisäys onnistui!");
      }
      else {
        alert("Vastauksen lisäys epäonnistui!");
      }
    });
  }

  public setSelectedQuestionID(id:string):void{
    this.selectedQuestionID = id;
    console.log("set id: ", id);
  }

  public doesQuizHaveAnswers(quiz: Quiz) {

    if (!this.answers || this.answers.length == 0) { return false; }

    for (let answer of this.answers) {
      if(quiz.questionArray.includes(answer.questionID)) return true;
    }
    return false;
  }

  public isPlayerInQuiz(player: Player, quiz: Quiz) {
    for (let answer of this.answers) {
      if (player._id === answer.playerID) {
        if (quiz.questionArray.includes(answer.questionID)) {
          return true;
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/players-table/players-table.component.ts